import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import slugify from "react-slugify";
import { ApiLinkContext } from "../context/ApiLinkContext";
import { Swiper, SwiperSlide } from "swiper/react"; // Swiper'ı React bileşeni olarak kullanıyoruz.
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import homeslider1 from "../assets/image/homeslider1.webp";
import biography from "../assets/image/bioqrafiyaimg.jpeg";
import GetInTouch from "./Home/GetInTouch";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";
const Projects = () => {
  const { loading, projects, main, error } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const [select, setSelect] = useState("0");
  const [selectedBtn, setSelectedBtn] = useState("all");
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile); // Temizleme
    };
  }, []);

  const projectsBtn = [
    { id: "all", btn: t.projectsall },
    { id: 0, btn: t.projectstamamlanan },
    { id: 1, btn: t.projectstamamlanmayan },
    { id: 2, btn: t.projectstamamlanmayan1 },
  ];
  const handleBtn = (btnId) => {
    setSelectedBtn(btnId);
  };

  return (
    <>
     <div>
        <div className="page-title-section section">
          <div className="page-title">
            <div className="container">
              <h1 className="title">{t.successprojects}</h1>
              <div className="d-flex justify-content-center">
                <p
                  className="text-center"
                  style={{ maxWidth: "600px", width: "100%" }}
                >
                  {t.projectsdesc}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="section ">
          <div className="container-fluid mx-4">
            {/* Course Top Bar Start */}
            <div className="row justify-content-between align-items-center max-mb-50">
              <div className="col-sm-auto col-12 max-mb-10"></div>
              <div className="d-flex justify-content-center align-items-center projectBtn">
                {projectsBtn.map((item) => {
                  return (
                    <button
                      className={`mx-2 ${
                        selectedBtn == item.id ? "btnActive" : ""
                      }`}
                      onClick={() => handleBtn(item.id)}
                      id="projectsBtn"
                    >
                      {item.btn}
                    </button>
                  );
                })}
              </div>
              <div className="d-flex justify-content-center">
                <select
                  name=""
                  id="selectProjects"
                  className="p-3"
                  onChange={(e) => setSelect(e.target.value)}
                >
                  <option value="all">{t.projectsall}</option>
                  <option value="0">{t.projectstamamlanan}</option>
                  <option value="1">{t.projectstamamlanmayan}</option>
                  <option value="2">{t.projectstamamlanmayan1}</option>
                </select>
              </div>
            </div>
            {/* Course Top Bar End */}
            {/* Courses Wrapper Start */}
            <div className="row row-cols-lg-4 row-cols-1 max-mb-n30 g-3">
              {/* Course Start */}
              {projects
                .filter((i) => {
                  if (isMobile && select === "all" ) {
                    return true; 
                  }  else {
                    if (!isMobile && selectedBtn === "all") {
                      return true
                    }
                  }
                  return isMobile ? i.aktiv == select : i.aktiv == selectedBtn;
                })  
                .map((item) => (
                  <NavLink
                    to={`/projects/${slugify(
                      `${item.id}-${item.name}`
                    ).toLowerCase()}`}
                  >
                  <div className="projectsBox">
                      <div className="imgBox">
                        <img src={item.ico} alt="" className="img-fluid" />
                      </div>
                      <div className="outline d-flex justify-content-center align-items-end">
                        <p> {language == "az"
                                  ? item.name
                                  : language == "en"
                                  ? item.nameEn
                                  : language == "ru"
                                  ? item.nameRu
                                  : language == "tr"
                                  ? item.nameTr
                                  : language == "de"
                                  ? item.nameDe
                                  : language == "pl"
                                  ? item.namePl
                                  : ""} <i className="fa-solid fa-square-arrow-up-right"></i></p>
                      </div>
                  </div>
                  </NavLink>
                ))}
              {/* Course End */}
            </div>
          </div>
      <GetInTouch/>
        </div>
      </div>
    </>
  );
};

export default Projects;
